// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.company.RentalManagerUserManagementCompanyWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  RentalManagerUserCompanyStatsDto,
  RentalManagerUserManagementInviteUserRequestDto,
  RentalManagerUserProfilesDto,
  RentalManagerUserProfileUpdateRequestDto,
  RentalManagerUserPropertyDetailsListDto,
  UserManagementActivityListDto,
  UserManagementCompanyDetailsDto,
  UserManagementCompanyPropertyDetailsListDto,
  UserManagementListingPermissionDetailsDto,
  UserManagementUnrecognizedUsersDto,
  Zuid,
} from '../..';

interface AddSingleUmcListingPermissionParams {
  email: string;
  listingAlias: ListingAlias;
}
interface CancelUserInvitationParams {
  email: string;
}
interface DeactivateUserParams {
  /**
   * @deprecated
   */
  userBrand: string;
  userToken: string;
}
interface DisableUmcListingPermissionParams {
  listingAlias: ListingAlias;
  userToken: string;
}
interface GetActivityHistoryParams {
  startTimestamp?: string;
}
interface GetCompanyListingsForUserParams {
  zuid: Zuid;
}
interface GetPendingProfileParams {
  email: string;
}
interface GetPendingUserPropertiesParams {
  email: string;
}
interface GetUmcListingPermissionDetailParams {
  listingAlias: ListingAlias;
}
interface GetUserCompanyPropertiesParams {
  userBrand: string;
  userToken: string;
}
interface GetUserProfilesParams {
  /**
   * @deprecated
   */
  userBrand?: string;
  userToken?: string;
}
interface ResendInviteEmailParams {
  email: string;
}
interface UpdateCompanyNameParams {
  companyName: string;
}
interface VerifyEmailParams {
  email: string;
}

export const RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_Path =
  '/api/web/v1/users/company/addSingleUmcListingPermission';

export const RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission = (
  getParams: AddSingleUmcListingPermissionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<AddSingleUmcListingPermissionParams, never, UserManagementListingPermissionDetailsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_addSingleUmcListingPermission_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_Path =
  '/api/web/v1/users/company/cancelUserInvitation';

/**
 * Cancel a pending invitation
 */
export const RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation = (
  getParams: CancelUserInvitationParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CancelUserInvitationParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_cancelUserInvitation_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation_Path =
  '/api/web/v1/users/company/createUserInvitation';

/**
 * Create a new pending user and send invitation
 */
export const RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation = (
  postData: RentalManagerUserManagementInviteUserRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentalManagerUserManagementInviteUserRequestDto, void>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_createUserInvitation_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_Path =
  '/api/web/v1/users/company/deactivateUser';

/**
 * Deactivate a user by removing permissions of features and properties
 */
export const RentalManagerUserManagementCompanyWebApiHandler_deactivateUser = (
  getParams: DeactivateUserParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DeactivateUserParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_deactivateUser_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_Path =
  '/api/web/v1/users/company/declineUserManagementInvitation';

/**
 * Decline invitation to user management
 */
export const RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation = (
  client = getClient(),
) => {
  return httpFrontEndRequest<never, never, void>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_declineUserManagementInvitation_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_Path =
  '/api/web/v1/users/company/disableUmcListingPermission';

/**
 * Disable UMC Listing Permission
 */
export const RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission = (
  getParams: DisableUmcListingPermissionParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<DisableUmcListingPermissionParams, never, UserManagementListingPermissionDetailsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_disableUmcListingPermission_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_Path =
  '/api/web/v1/users/company/getActivityHistory';

export const RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory = (
  getParams: GetActivityHistoryParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetActivityHistoryParams, never, UserManagementActivityListDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getActivityHistory_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Path =
  '/api/web/v1/users/company/getCompanyListingsForUser';

export const RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser = (
  getParams: GetCompanyListingsForUserParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetCompanyListingsForUserParams, never, UserManagementCompanyPropertyDetailsListDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getCompanyListingsForUser_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Path =
  '/api/web/v1/users/company/getPendingProfile';

/**
 * Get an invited user's pending profile
 */
export const RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile = (
  getParams: GetPendingProfileParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPendingProfileParams, never, RentalManagerUserProfilesDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getPendingProfile_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Path =
  '/api/web/v1/users/company/getPendingUserProperties';

/**
 * Get a pending user's properties
 */
export const RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties = (
  getParams: GetPendingUserPropertiesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetPendingUserPropertiesParams, never, RentalManagerUserPropertyDetailsListDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getPendingUserProperties_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_Path =
  '/api/web/v1/users/company/getUmcListingPermissionDetail';

export const RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail = (
  getParams: GetUmcListingPermissionDetailParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUmcListingPermissionDetailParams, never, UserManagementListingPermissionDetailsDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUmcListingPermissionDetail_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_Path =
  '/api/web/v1/users/company/getUnrecognizedUsers';

export const RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UserManagementUnrecognizedUsersDto>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUnrecognizedUsers_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_Path =
  '/api/web/v1/users/company/getUserCompanyDetails';

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails = (client = getClient()) => {
  return httpFrontEndRequest<never, never, UserManagementCompanyDetailsDto>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyDetails_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_Path =
  '/api/web/v1/users/company/getUserCompanyProperties';

/**
 * Get a user's company properties
 */
export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties = (
  getParams: GetUserCompanyPropertiesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUserCompanyPropertiesParams, never, RentalManagerUserPropertyDetailsListDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyProperties_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Path =
  '/api/web/v1/users/company/getUserCompanyStats';

export const RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RentalManagerUserCompanyStatsDto>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUserCompanyStats_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Path =
  '/api/web/v1/users/company/getUserManagementProfiles';

/**
 * Get the current user's company users
 */
export const RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RentalManagerUserProfilesDto>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUserManagementProfiles_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Path =
  '/api/web/v1/users/company/getUserProfiles';

/**
 * Get user profiles including feature access and properties permissions
 */
export const RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles = (
  getParams: GetUserProfilesParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<GetUserProfilesParams, never, RentalManagerUserProfilesDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_getUserProfiles_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_Path =
  '/api/web/v1/users/company/resendInviteEmail';

export const RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail = (
  getParams: ResendInviteEmailParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ResendInviteEmailParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_resendInviteEmail_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_Path =
  '/api/web/v1/users/company/updateCompanyName';

export const RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName = (
  getParams: UpdateCompanyNameParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<UpdateCompanyNameParams, never, string>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_updateCompanyName_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Path =
  '/api/web/v1/users/company/updateUserSettings';

/**
 * Update existing user settings
 */
export const RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings = (
  postData: RentalManagerUserProfileUpdateRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentalManagerUserProfileUpdateRequestDto, void>(
    {
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_updateUserSettings_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_Path = '/api/web/v1/users/company/verifyEmail';

/**
 * Verify if an email can be added to a company
 */
export const RentalManagerUserManagementCompanyWebApiHandler_verifyEmail = (
  getParams: VerifyEmailParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<VerifyEmailParams, never, void>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserManagementCompanyWebApiHandler_verifyEmail_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
